import { toPersianDigits } from "../../../helper/toPersianDigits";

export const buildPlanFromChallenge = (challenge) => {
  const initialBalance = Number(challenge?.initial_balance ?? 0);
  const cost = Number(challenge?.cost ?? 0);
  const discountCost = Number(challenge?.discount_cost ?? 0);
  const discountPercent =
    challenge?.discaount_percent ?? challenge?.discount_percent ?? null;
  const profitSplitRatio = Number(challenge?.profit_split_ratio ?? 0) * 100;

  return {
    id: challenge?.id ?? "",
    planName: challenge?.name ?? "",
    description: Number.isFinite(initialBalance)
      ? `$${initialBalance.toLocaleString()}`
      : "",
    price: Number.isFinite(cost) ? cost.toFixed(2) : "0",
    discountPrice:
      Number.isFinite(discountCost) && discountCost > 0
        ? discountCost.toFixed(2)
        : null,
    discountPercent,
    features: [
      {
        key: "تارگت مرحله ۱",
        value: `${toPersianDigits(challenge?.phase1?.profit_target ?? "")}٪`,
      },
      {
        key: "تارگت مرحله ۲",
        value: `${toPersianDigits(challenge?.phase2?.profit_target ?? "")}٪`,
      },
      {
        key: "دراودان کل",
        value: `${toPersianDigits(
          challenge?.phase1?.max_drawdown_limit ?? "",
        )}٪`,
      },
      {
        key: "دراودان روزانه",
        value: `${toPersianDigits(
          challenge?.phase1?.daily_drawdown_limit ?? "",
        )}٪`,
      },
      {
        key: "دراودان معامله",
        value: `${toPersianDigits(
          challenge?.phase1?.trade_drawdown_limit ?? "",
        )}٪`,
      },
      {
        key: "حداقل روزهای معامله",
        value: `${toPersianDigits(
          challenge?.phase1?.min_trading_days ?? "",
        )} روز`,
      },
      {
        key: "زمان مرحله ۱",
        value: `${toPersianDigits(challenge?.phase1?.duration ?? "")} روز`,
      },
      {
        key: "زمان مرحله ۲",
        value: `${toPersianDigits(challenge?.phase2?.duration ?? "")} روز`,
      },
      {
        key: "تقسیم سود",
        value: `${toPersianDigits(profitSplitRatio)}٪`,
      },
    ],
    buttonText: "مشاهده",
    buttonVariant: "secondary",
    isPopular: Boolean(challenge?.discount_cost),
  };
};
